import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CALENDLY } from "@/lib/content";

const base = "group inline-flex max-w-full items-center gap-3 rounded-full pl-6 pr-2 py-2 text-sm font-semibold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5";
const variants = {
  gold: "bg-[#D4AF37] text-[#082F24] hover:bg-[#E6C65A]",
  emerald: "bg-[#082F24] text-[#FAF8F5] hover:bg-[#0F5A47]",
  ghostLight: "border border-[#FAF8F5]/30 text-[#FAF8F5] hover:bg-[#FAF8F5]/10",
  ghostDark: "border border-[#082F24]/25 text-[#082F24] hover:bg-[#082F24]/5",
};
const dot = {
  gold: "bg-[#082F24] text-[#D4AF37]",
  emerald: "bg-[#D4AF37] text-[#082F24]",
  ghostLight: "bg-[#FAF8F5] text-[#082F24]",
  ghostDark: "bg-[#082F24] text-[#FAF8F5]",
};

const Inner = ({ children, variant }) => (
  <>
    <span>{children}</span>
    <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full transition-transform duration-500 group-hover:rotate-45 ${dot[variant]}`}>
      <ArrowUpRight className="h-4 w-4" />
    </span>
  </>
);

export const BookButton = ({ children = "Book Consultation", variant = "gold", testId = "book-consultation-btn" }) => (
  <a href={CALENDLY} target="_blank" rel="noopener noreferrer" data-testid={testId} className={`${base} ${variants[variant]}`}>
    <Inner variant={variant}>{children}</Inner>
  </a>
);

export const PillLink = ({ to, children, variant = "ghostDark", testId }) => (
  <Link to={to} data-testid={testId} className={`${base} ${variants[variant]}`}>
    <Inner variant={variant}>{children}</Inner>
  </Link>
);
